import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	Interactive,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';
import {CloseUpFrame} from './CloseUpFrame';

const TimelineLeftDragContent = () => {
	const {fps} = useVideoConfig();
	// Cursor keyframes were captured at 60 fps.
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={Math.round((271 / 60) * fps)}
			style={{
				width: 2560,
				height: 1134,
				rotate: '0.948186 0.15788 -0.275711 26.23743deg',
				scale: 1.378,
				translate: '420px 80px',
			}}
			trimBefore={(1190 / 60) * fps}
		>
			<Video
				src="https://remotion.media/studio-close-ups/basics-showcase/timeline-left-drag-02de7769165d.mp4"
				durationInFrames={Math.round((1461 / 60) * fps)}
				muted
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						-1183, -869, -834, -833, -821, -820, -816, -811, -799, -511, -505,
						-372, -368, -366, -364, -210, -186, 36, 213,
					],
					[
						'auto',
						'custom',
						'auto',
						'custom',
						'auto',
						'custom',
						'auto',
						'custom',
						'auto',
						'custom',
						'auto',
						'custom',
						'auto',
						'custom',
						'auto',
						'custom',
						'auto',
						'custom',
						'auto',
					],
					{
						easing: [
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
						],

						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				customCursor={
					[
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, e-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20transform%3D%22translate(32%200)%20scale(-1%201)%22%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E") 2 12, ew-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize',
					][
						interpolate(
							frame,
							[
								321, 353, 354, 357, 358, 370, 372, 679, 818, 819, 980, 1226,
								1401,
							],
							[0, 1, 2, 0, 1, 0, 1, 2, 1, 3, 2, 0, 2],
							{
								easing: Easing.step1,
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						)
					]
				}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[-1190, -1143, -1099, -479, -92, 58, 189, 250, 255],
						[
							3.341167593692486, 3.007050834323237, 3.341167593692486,
							3.007050834323237, 3.341167593692486, 3.007050834323237,
							3.341167593692486, 3.007050834323237, 3.341167593692486,
						],
						{
							easing: [
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
							],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							-1183, -1182, -1181, -1180, -1179, -1178, -1177, -1176, -1175,
							-1174, -1173, -1172, -1171, -1170, -1169, -1168, -1167, -1166,
							-1165, -1164, -1163, -1162, -1161, -1160, -1159, -1158, -1157,
							-1156, -1155, -1154, -1153, -1152, -1149, -1148, -1147, -1146,
							-1145, -1144, -1143, -1134, -1133, -1132, -1131, -1128, -1127,
							-1125, -1124, -1121, -1120, -1119, -1118, -1117, -1116, -1115,
							-1114, -1113, -1112, -1111, -1110, -1109, -1108, -1107, -1106,
							-1105, -1104, -1103, -1102, -1089, -1088, -1087, -1082, -1081,
							-1078, -1077, -1076, -1075, -1056, -1055, -1053, -1052, -1051,
							-1049, -1048, -1047, -1045, -1044, -1043, -1041, -1040, -1039,
							-1038, -1037, -1036, -1035, -1034, -1033, -1032, -1031, -1030,
							-1029, -1028, -1027, -1008, -1007, -999, -998, -995, -994, -993,
							-991, -990, -988, -987, -986, -983, -982, -979, -978, -977, -974,
							-973, -972, -970, -969, -968, -966, -965, -964, -963, -962, -961,
							-960, -958, -957, -946, -945, -943, -942, -941, -939, -938, -937,
							-935, -934, -931, -930, -929, -927, -926, -925, -923, -922, -921,
							-919, -918, -916, -915, -914, -913, -912, -910, -909, -908, -907,
							-906, -905, -904, -903, -902, -901, -900, -899, -898, -897, -896,
							-895, -894, -893, -892, -891, -890, -889, -887, -886, -884, -883,
							-882, -880, -879, -878, -876, -875, -874, -870, -869, -866, -865,
							-859, -858, -839, -838, -837, -836, -835, -834, -833, -832, -831,
							-830, -829, -824, -823, -822, -821, -820, -819, -818, -817, -816,
							-815, -814, -813, -812, -811, -810, -809, -808, -807, -806, -804,
							-803, -802, -801, -800, -799, -798, -797, -796, -795, -771, -770,
							-767, -766, -765, -763, -762, -761, -758, -757, -755, -754, -753,
							-751, -750, -749, -747, -746, -745, -742, -741, -740, -739, -736,
							-735, -733, -732, -731, -730, -729, -727, -726, -724, -723, -712,
							-711, -710, -709, -708, -707, -706, -705, -704, -703, -702, -701,
							-700, -690, -689, -688, -687, -686, -685, -684, -683, -682, -681,
							-680, -677, -676, -675, -674, -673, -672, -671, -670, -651, -650,
							-648, -647, -644, -643, -642, -640, -639, -637, -636, -635, -634,
							-633, -632, -631, -630, -629, -628, -627, -626, -625, -624, -623,
							-622, -621, -617, -616, -615, -614, -613, -612, -611, -610, -609,
							-608, -607, -605, -604, -603, -602, -601, -600, -598, -597, -595,
							-594, -592, -591, -590, -588, -587, -584, -583, -582, -580, -579,
							-577, -576, -574, -573, -564, -563, -562, -561, -551, -550, -549,
							-548, -547, -546, -545, -544, -543, -542, -526, -525, -524, -523,
							-522, -521, -520, -519, -518, -517, -516, -515, -514, -513, -512,
							-511, -510, -507, -506, -505, -504, -503, -502, -501, -500, -499,
							-498, -497, -496, -495, -494, -493, -492, -491, -490, -489, -488,
							-487, -486, -485, -484, -483, -482, -481, -480, -476, -475, -469,
							-468, -467, -466, -465, -463, -462, -461, -460, -459, -458, -457,
							-456, -455, -454, -453, -452, -451, -450, -448, -447, -416, -415,
							-391, -390, -389, -388, -387, -386, -385, -384, -383, -382, -381,
							-380, -379, -378, -377, -376, -375, -374, -373, -372, -371, -370,
							-369, -368, -367, -366, -365, -364, -363, -362, -361, -360, -359,
							-358, -357, -356, -355, -354, -353, -352, -351, -350, -349, -348,
							-347, -346, -345, -344, -343, -342, -341, -340, -339, -338, -337,
							-336, -335, -334, -333, -332, -331, -330, -329, -328, -327, -326,
							-325, -324, -323, -321, -320, -319, -318, -317, -316, -315, -314,
							-313, -312, -311, -310, -309, -308, -307, -306, -305, -304, -303,
							-302, -301, -300, -299, -298, -297, -296, -295, -294, -293, -292,
							-291, -290, -289, -288, -287, -286, -285, -284, -283, -282, -281,
							-280, -279, -278, -277, -276, -275, -274, -273, -272, -271, -270,
							-269, -268, -267, -266, -265, -264, -263, -262, -261, -260, -259,
							-258, -257, -256, -255, -254, -253, -252, -251, -250, -249, -248,
							-247, -246, -245, -244, -243, -242, -241, -240, -239, -238, -237,
							-236, -235, -234, -233, -232, -231, -230, -229, -228, -227, -226,
							-225, -224, -223, -222, -221, -220, -219, -218, -217, -216, -215,
							-214, -213, -212, -211, -210, -209, -208, -207, -206, -205, -196,
							-195, -194, -193, -192, -191, -190, -189, -188, -187, -186, -185,
							-184, -183, -182, -181, -180, -179, -178, -177, -176, -175, -174,
							-173, -172, -171, -170, -169, -168, -167, -166, -165, -164, -163,
							-162, -161, -160, -159, -158, -157, -156, -155, -154, -153, -152,
							-151, -150, -149, -148, -147, -146, -145, -144, -143, -142, -141,
							-140, -139, -138, -137, -136, -135, -134, -133, -132, -131, -130,
							-129, -128, -127, -126, -125, -124, -123, -122, -121, -120, -119,
							-118, -117, -116, -115, -114, -113, -112, -111, -110, -109, -108,
							-107, -106, -105, -104, -103, -102, -101, -100, -99, -98, -97,
							-96, -93, -92, -79, -78, -77, -76, -75, -74, -73, -72, -71, -70,
							-69, -68, -67, -66, -65, -64, -63, -62, -61, -60, -59, -58, -57,
							-56, -55, -54, -53, -52, -51, -50, -49, -48, -47, -46, -45, -44,
							-43, -42, -41, -40, -39, -38, -37, -36, -35, -34, -33, -32, -31,
							-30, -29, -28, -27, -26, -25, -24, -23, -22, -21, -20, -19, -18,
							-17, -16, -15, -14, -13, -12, -11, -10, -9, -8, -7, -6, -5, -4,
							-3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16,
							17, 18, 19, 21, 23, 25, 26, 28, 30, 31, 32, 33, 34, 35, 36, 37,
							38, 39, 40, 41, 42, 43, 44, 45, 47, 51, 77, 78, 79, 80, 81, 82,
							83, 84, 89, 92, 93, 95, 96, 98, 101, 103, 106, 107, 109, 112, 114,
							117, 120, 123, 127, 128, 130, 133, 136, 138, 141, 144, 147, 149,
							152, 154, 155, 157, 160, 162, 165, 168, 170, 173, 174, 175, 177,
							178, 180, 182, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218,
							219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231,
							232, 233, 234, 235, 236, 239, 241, 242, 243, 245, 246, 247,
						],
						[
							'1605.2744115382852px 927.5524988911378px',
							'1636.0235945489862px 843.9058461256099px',
							'1639.2211963476373px 827.8917342605291px',
							'1693.9850214380033px 702.3369207788037px',
							'1712.6485747933948px 664.9967626321076px',
							'1762.009105415836px 572.8405736513942px',
							'1763.7579978281594px 569.3166859549216px',
							'1797.482908226993px 513.117202914141px',
							'1811.5393047051446px 490.3946529898495px',
							'1823.8468087709728px 466.70629680800624px',
							'1829.276206110723px 455.83445069259284px',
							'1839.169194532672px 438.25416651796866px',
							'1854.491580294371px 409.8020362279311px',
							'1864.084385690324px 396.98552616150135px',
							'1875.9089866273764px 370.0995681810071px',
							'1875.9089866273764px 370.0995681810071px',
							'1898.8925652699252px 324.0671537163454px',
							'1904.1522939428082px 317.0193783234003px',
							'1907.1671756386793px 312.2164499074674px',
							'1911.4480466180978px 306.134480772074px',
							'1916.224872162205px 303.09349620437735px',
							'1919.2397538580758px 298.2905677884444px',
							'1920.9886462703994px 294.76668009197186px',
							'1927.031461098054px 290.4466548048148px',
							'1930.5422973586137px 288.6847109565785px',
							'1933.074275925709px 286.1266295176577px',
							'1935.6062544928038px 284.84758879819725px',
							'1939.4042223434465px 284.84758879819725px',
							'1939.4042223434465px 284.84758879819725px',
							'1940.3700286009982px 284.84758879819725px',
							'1940.3700286009982px 284.84758879819725px',
							'1941.2705776789858px 284.84758879819725px',
							'1941.2705776789858px 284.84758879819725px',
							'1941.2705776789858px 288.2409621355412px',
							'1941.2705776789858px 290.7729407026363px',
							'1941.2705776789858px 293.3049192697314px',
							'1941.2705776789858px 294.5709085532789px',
							'1941.2705776789858px 298.36887640392155px',
							'1941.2705776789858px 299.6348656874691px',
							'1941.2705776789858px 299.6348656874691px',
							'1930.4639887431365px 299.6348656874691px',
							'1919.709605550939px 299.6348656874691px',
							'1897.8092960891577px 299.6348656874691px',
							'1897.8092960891577px 299.6348656874691px',
							'1742.940957547146px 299.6348656874691px',
							'1742.940957547146px 299.6348656874691px',
							'1703.8910612958648px 299.6348656874691px',
							'1703.8910612958648px 299.6348656874691px',
							'1609.985979902828px 321.1958378155159px',
							'1609.985979902828px 321.1958378155159px',
							'1532.9825080169464px 338.8674820415301px',
							'1497.861093975437px 348.70826471982747px',
							'1470.9751359949425px 354.6075137524408px',
							'1470.9751359949425px 354.6075137524408px',
							'1435.8798248252585px 363.3650272499707px',
							'1424.3162526064636px 365.10086822638124px',
							'1424.3162526064636px 365.10086822638124px',
							'1420.6357476790367px 365.10086822638124px',
							'1420.6357476790367px 365.10086822638124px',
							'1417.3859401367342px 366.2885488944516px',
							'1412.4655487975856px 367.1760465365262px',
							'1395.7075050854717px 370.3344940274386px',
							'1395.7075050854717px 370.3344940274386px',
							'1383.152023737299px 374.90249659694007px',
							'1373.6375269568232px 377.069034958475px',
							'1371.209959877031px 377.7999153695953px',
							'1369.709044747052px 378.4655386011512px',
							'1369.709044747052px 378.4655386011512px',
							'1369.709044747052px 381.9241691180594px',
							'1369.709044747052px 399.47835042085785px',
							'1369.709044747052px 399.47835042085785px',
							'1369.709044747052px 457.59639454082907px',
							'1369.709044747052px 457.59639454082907px',
							'1369.709044747052px 470.2562873763045px',
							'1366.498391512488px 486.2573478054724px',
							'1347.0648034382377px 553.6027571158367px',
							'1347.0648034382377px 553.6027571158367px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1343.540915741765px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1346.8820833354575px 550.9663670614386px',
							'1285.1618429035366px 564.6573233340301px',
							'1263.0266075953239px 572.0313846247967px',
							'1202.7420251138178px 582.5899962783014px',
							'1202.7420251138178px 582.5899962783014px',
							'1106.9314340775031px 595.5761750115985px',
							'1068.7820869042096px 602.4542817376763px',
							'1041.8961289237154px 605.6518835363273px',
							'1038.372241227243px 607.4007759486508px',
							'1027.8266810096509px 607.4007759486508px',
							'1026.8478233161863px 607.4007759486508px',
							'1026.8478233161863px 607.4007759486508px',
							'1024.72043926239px 607.4007759486508px',
							'1019.917510846457px 607.4007759486508px',
							'1009.6851850907738px 607.4007759486508px',
							'1002.976747031563px 607.4007759486508px',
							'985.3964628569389px 607.4007759486508px',
							'978.6880247977283px 605.1559289716387px',
							'971.9795867385176px 605.1559289716387px',
							'949.8965571739562px 602.9110819946264px',
							'948.6175164544959px 602.9110819946264px',
							'940.2907003420904px 602.9110819946264px',
							'933.2429249491453px 601.1491381463902px',
							'928.4399965332124px 601.1491381463902px',
							'924.9161088367398px 599.387194298154px',
							'921.0789866783587px 598.1081535786935px',
							'918.5209052394378px 598.1081535786935px',
							'918.5209052394378px 598.1081535786935px',
							'916.4065726215542px 597.0509872697518px',
							'915.4277149280897px 597.0509872697518px',
							'915.4277149280897px 597.0509872697518px',
							'913.4569481052476px 595.99382096081px',
							'912.1779073857872px 595.99382096081px',
							'901.6062442963696px 594.2318771125738px',
							'901.6062442963696px 594.2318771125738px',
							'891.034581206952px 592.4699332643374px',
							'886.231652791019px 592.4699332643374px',
							'881.4287243750861px 590.7079894161012px',
							'880.1496836556256px 590.7079894161012px',
							'879.1708259621611px 590.7079894161012px',
							'879.1708259621611px 590.7079894161012px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'879.1186202185096px 587.719210592056px',
							'899.2308829602289px 590.7079894161012px',
							'937.3541272616966px 590.7079894161012px',
							'970.3351058134971px 587.9802393103132px',
							'1018.5210072037809px 577.8653764778458px',
							'1085.9186222577964px 558.170759685338px',
							'1124.0418665592642px 543.8924887966679px',
							'1150.9017216679329px 532.0417849877898px',
							'1164.2924949145283px 529.7969380107777px',
							'1169.0693204586357px 528.5178972913172px',
							'1171.6012990257307px 528.5178972913172px',
							'1171.6012990257307px 528.5178972913172px',
							'1165.1016839411259px 530.2667897036406px',
							'1147.5213997665016px 537.9279825844902px',
							'1134.1045236480802px 544.6233692077881px',
							'1123.872197892397px 548.6040571612108px',
							'1110.4553217739756px 553.0676482434093px',
							'1096.0595879620896px 554.8165406557328px',
							'1050.8102596521996px 554.8165406557328px',
							'1050.8102596521996px 554.8165406557328px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1049.5181674968264px 554.3075346551311px',
							'1038.3200354835915px 554.8165406557328px',
							'1020.7397513089672px 554.8165406557328px',
							'1003.1594671343431px 554.8165406557328px',
							'985.579182959719px 559.7630348667071px',
							'937.3671786976095px 567.1370961574737px',
							'893.096708081184px 574.4981060123275px',
							'861.0684843510224px 580.8933096096296px',
							'834.1825263705283px 586.8056100781557px',
							'812.4388341397014px 594.9497060877811px',
							'812.4388341397014px 594.9497060877811px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'812.2952683446599px 594.401545779441px',
							'819.9303583536837px 594.9497060877811px',
							'833.3211316002794px 585.9964210515583px',
							'846.1245902307963px 573.1799109851286px',
							'884.534966122347px 541.151687254967px',
							'902.2718675279256px 520.1780297429989px',
							'915.8453608773012px 501.14903618204715px',
							'923.023650629375px 483.56875200742303px',
							'931.1677466390004px 461.82505977659616px',
							'937.0800471075265px 434.9391017961019px',
							'942.5094444472768px 413.19540956527504px',
							'946.9730355294754px 399.77853344685366px',
							'948.7219279417988px 388.26716697171px',
							'948.7219279417988px 383.46423855577706px',
							'948.7219279417988px 382.4070722468353px',
							'949.9879172253463px 382.4070722468353px',
							'949.9879172253463px 380.07086521843314px',
							'953.0027989212173px 371.74404910602766px',
							'956.5005837458641px 364.6962737130825px',
							'957.7665730294117px 359.8933452971496px',
							'959.515465441735px 355.09041688121664px',
							'960.7814547252826px 353.81137616175624px',
							'962.0474440088301px 351.4751691333541px',
							'962.0474440088301px 350.1961284138937px',
							'964.605525447751px 346.306800511861px',
							'964.605525447751px 343.7487190729402px',
							'965.8715147312985px 341.19063763401937px',
							'966.9156296043274px 340.1334713250776px',
							'966.9156296043274px 340.1334713250776px',
							'966.9156296043274px 339.5983624526503px',
							'966.9156296043274px 339.5983624526503px',
							'960.5856831865897px 339.06325358022303px',
							'960.5856831865897px 339.06325358022303px',
							'927.2784187369678px 339.06325358022303px',
							'890.7213467450433px 339.06325358022303px',
							'890.7213467450433px 339.06325358022303px',
							'858.2754770656702px 339.55920814491174px',
							'858.2754770656702px 339.55920814491174px',
							'840.877912993826px 344.40129086858326px',
							'830.1757355452798px 348.59080179661174px',
							'821.3399134322727px 352.41487251908006px',
							'813.0000458839544px 355.5863714459054px',
							'801.5147822806365px 359.7889338098467px',
							'787.2756656997049px 364.46134786665107px',
							'768.8600896266576px 369.70802510362125px',
							'768.8600896266576px 369.70802510362125px',
							'745.5502250862874px 376.9515720352593px',
							'745.5502250862874px 376.9515720352593px',
							'714.5139104855033px 387.04033199590106px',
							'714.5139104855033px 387.04033199590106px',
							'694.3885963078711px 393.47468990094166px',
							'694.3885963078711px 393.47468990094166px',
							'527.3041137514211px 433.75142112803155px',
							'527.3041137514211px 433.75142112803155px',
							'528.25686857306px 433.75142112803155px',
							'529.5228578566075px 433.75142112803155px',
							'533.1250541685573px 433.75142112803155px',
							'536.7011476086813px 433.75142112803155px',
							'536.7011476086813px 433.75142112803155px',
							'540.773195613494px 433.75142112803155px',
							'545.9285127990742px 433.75142112803155px',
							'549.4393490596339px 433.75142112803155px',
							'558.6014570704625px 432.3810203571811px',
							'569.7734862118717px 430.5016135857291px',
							'583.8037798181975px 427.19960029977517px',
							'590.9298638266198px 424.90254757911157px',
							'590.9298638266198px 424.90254757911157px',
							'619.6169199630889px 418.376829622681px',
							'619.6169199630889px 418.376829622681px',
							'647.8863301503465px 413.1432038216236px',
							'661.2771033969422px 411.1202312551301px',
							'670.2695427409035px 411.00276833191435px',
							'697.599249542435px 408.7187670471636px',
							'712.1777034571011px 406.87851458345017px',
							'726.5864887048999px 406.51307437789006px',
							'726.5864887048999px 406.51307437789006px',
							'752.2325602736723px 403.79837570801493px',
							'752.2325602736723px 403.79837570801493px',
							'778.3484835353078px 401.48827155143846px',
							'778.3484835353078px 401.48827155143846px',
							'802.9895945387898px 400.7443397044054px',
							'819.6693296354265px 399.72632770320223px',
							'830.436764263537px 399.7002248313765px',
							'846.0071273075806px 399.6871733954636px',
							'858.2493741938445px 399.6871733954636px',
							'877.8134766272235px 399.6871733954636px',
							'898.7088255237144px 399.6871733954636px',
							'908.3016309196674px 399.6871733954636px',
							'928.479150840951px 399.6871733954636px',
							'940.512574752609px 399.6871733954636px',
							'955.5739317960509px 399.6871733954636px',
							'964.8012969864438px 399.6871733954636px',
							'974.0286621768367px 399.6871733954636px',
							'982.9819472130596px 399.6871733954636px',
							'998.095510000153px 399.6871733954636px',
							'1003.0289527752145px 399.6871733954636px',
							'1015.023222379134px 399.6871733954636px',
							'1033.2430269134884px 399.6871733954636px',
							'1051.2801113450626px 399.6871733954636px',
							'1051.2801113450626px 399.6871733954636px',
							'1084.5221186151202px 397.6903037007958px',
							'1106.774816846549px 396.30685149403257px',
							'1129.7322926172717px 394.8059363640535px',
							'1151.2019046939286px 393.5660499523317px',
							'1179.7845493430948px 391.64748887314107px',
							'1188.3854456096703px 390.51201394872214px',
							'1221.9537387775495px 387.3796693296354px',
							'1249.8577087592469px 386.97507481633676px',
							'1273.5460649410902px 386.93592050859814px',
							'1295.864020352083px 386.90981763677246px',
							'1311.369126216562px 385.0043079934947px',
							'1331.0376401372441px 384.2864790182873px',
							'1350.1710451854988px 382.98133542700117px',
							'1369.0042672077575px 381.5065231688479px',
							'1385.605693688917px 379.1964190122714px',
							'1404.4650185830017px 376.92546916343355px',
							'1412.7135260799298px 376.220691624139px',
							'1420.3877703966923px 375.2548853665873px',
							'1424.7861042993266px 375.1374224433716px',
							'1426.247865121567px 374.5109535195542px',
							'1427.6182658924174px 373.8583817239112px',
							'1428.2838891239735px 373.41463290287385px',
							'1428.2838891239735px 373.41463290287385px',
							'1428.2838891239735px 372.48798095306074px',
							'1428.2838891239735px 372.48798095306074px',
							'1428.2838891239735px 371.57438043916045px',
							'1428.2838891239735px 371.57438043916045px',
							'1426.8221283017328px 371.09147731038456px',
							'1425.5952933259239px 371.0653744385588px',
							'1420.7271077304267px 371.03927156673313px',
							'1414.671241466859px 371.0131686949074px',
							'1404.23009273657px 371.0131686949074px',
							'1404.23009273657px 371.0131686949074px',
							'1368.8737528486288px 378.50469290888975px',
							'1335.749208501787px 390.00300794812057px',
							'1307.9235471355667px 400.5616196016253px',
							'1266.132849342585px 414.9312505416856px',
							'1233.4390023808674px 425.89445670848903px',
							'1216.4329813864092px 431.1280825095464px',
							'1172.5932081551082px 445.7978964756025px',
							'1162.9351455795909px 448.57785232504193px',
							'1144.8458554043652px 454.75118151182534px',
							'1139.3642523209635px 457.2179028993561px',
							'1136.114444778661px 457.66165172039337px',
							'1134.496066725466px 458.8493323884638px',
							'1133.1648202623544px 458.95374387576663px',
							'1131.9379852865454px 458.9798467475924px',
							'1129.901961284139px 459.9978587487956px',
							'1128.7403834878944px 460.1283731079242px',
							'1127.4743942043467px 460.20668172340135px',
							'1123.5198091227498px 462.12524280259197px',
							'1122.3060255828536px 462.777814598235px',
							'1120.387464503663px 463.66531224030956px',
							'1119.0823209123769px 464.3700897796041px',
							'1116.537290909369px 465.5708218835873px',
							'1113.809540803581px 466.9020683466992px',
							'1111.094842133706px 468.233314809811px',
							'1108.5106578229593px 469.49930409335855px',
							'1107.4273886421918px 470.1257730171759px',
							'1105.8742677685614px 470.6739333255161px',
							'1105.2216959729183px 471.2742993775077px',
							'1103.8121408943293px 472.4358771737524px',
							'1103.8121408943293px 472.4358771737524px',
							'1102.7419231494746px 472.8665745588768px',
							'1101.8152711996615px 473.3233748158269px',
							'1101.2801623272342px 473.8715351241671px',
							'1100.6536934034168px 474.3805411247687px',
							'1098.865646683355px 475.05921579223747px',
							'1098.2261263236246px 475.6856847160548px',
							'1096.1770508853053px 476.1946907166564px',
							'1095.0154730890608px 476.8081082045609px',
							'1093.7625352414261px 477.49983430794254px',
							'1091.2827624179824px 479.24872672026595px',
							'1088.985709697319px 480.5016645679006px',
							'1086.6756055407425px 481.5196765691038px',
							'1085.3574105135435px 482.17224836474685px',
							'1082.681866151407px 483.477391956033px',
							'1081.2984139446437px 484.1821694953275px',
							'1078.6750753261585px 484.9130499064477px',
							'1074.094021320744px 486.5575308314682px',
							'1069.51296731533px 488.2542175001402px',
							'1067.9467950057865px 488.4238861670074px',
							'1063.6920268981937px 490.40770442576235px',
							'1061.016482536057px 491.07332765731826px',
							'1059.7374418165969px 491.6997965811356px',
							'1056.892228787593px 492.83527150555454px',
							'1054.8823076570125px 493.50089473711046px',
							'1053.5771640657263px 494.1273636609278px',
							'1050.9799283190669px 495.4716615599525px',
							'1048.6045669829261px 496.52882786889427px',
							'1047.6648635972px 496.97257668993154px',
							'1046.2814113904367px 497.0639367413216px',
							'1041.569843025894px 498.9302920768607px',
							'1039.2336359974918px 499.7786354111967px',
							'1037.6935665597741px 500.53561869414267px',
							'1032.1858606045466px 502.0756881318603px',
							'1032.1858606045466px 502.0756881318603px',
							'1022.3842322339879px 504.45104946800103px',
							'1017.2550179202333px 505.40380428963994px',
							'1007.5578010369774px 507.1918510097019px',
							'1005.1563368290109px 508.06629721586364px',
							'995.9028687667923px 510.3894528083529px',
							'992.261518147104px 510.55912147522014px',
							'982.0422438273337px 512.3732710671078px',
							'975.7384002814216px 514.1613177871699px',
							'972.1884097131234px 514.1613177871699px',
							'966.1194920136429px 515.4142556348045px',
							'961.0424834435398px 516.8890678929579px',
							'954.9213600004078px 517.1109423034765px',
							'949.6224770197862px 518.3508287151983px',
							'944.649879936986px 518.3899830229369px',
							'938.3329849551612px 520.1388754352603px',
							'928.3616879177351px 522.4489795918367px',
							'920.8962665755786px 523.5191973366914px',
							'917.1244015967617px 524.4066949787659px',
							'909.5676202032149px 525.346398364492px',
							'900.2749978332578px 527.1083422127282px',
							'892.7182164397111px 528.5570515990559px',
							'890.0687749494002px 528.7136688300102px',
							'884.91345776382px 528.8050288814002px',
							'882.3684277608121px 528.8050288814002px',
							'872.7495194930333px 530.9193614992837px',
							'870.8831641574942px 531.4414189357982px',
							'864.6576292270594px 532.8770768862129px',
							'860.6769412736367px 533.0467455530801px',
							'859.2021290154834px 533.059796988993px',
							'855.1692353184092px 534.3127348366277px',
							'852.8591311618327px 534.3127348366277px',
							'850.953621518555px 534.3127348366277px',
							'845.6547385379333px 534.3127348366277px',
							'844.2843377670829px 534.3127348366277px',
							'837.9021856056937px 536.0485758130382px',
							'834.1825263705283px 536.061627248951px',
							'828.7792319026037px 537.3145650965857px',
							'824.9160068723968px 537.3145650965857px',
							'819.9825640973352px 537.3145650965857px',
							'819.9825640973352px 537.3145650965857px',
							'817.0720938887671px 537.3145650965857px',
							'813.6787205514232px 538.5675029442205px',
							'813.6787205514232px 538.5675029442205px',
							'815.2448928609665px 538.5675029442205px',
							'815.2448928609665px 538.5675029442205px',
							'817.5158427098044px 538.5675029442205px',
							'820.2174899437667px 538.5675029442205px',
							'821.3660163040985px 538.5675029442205px',
							'823.9371491789321px 538.5675029442205px',
							'824.9943154878739px 538.5675029442205px',
							'827.0694937980188px 538.5675029442205px',
							'829.692832416504px 538.5675029442205px',
							'834.4827093965241px 538.5675029442205px',
							'839.5597179666271px 538.5675029442205px',
							'853.3811885983472px 538.5675029442205px',
							'858.6800715789689px 538.5675029442205px',
							'873.4542970323279px 538.5675029442205px',
							'878.792334320688px 538.5675029442205px',
							'889.6511290001887px 538.5675029442205px',
							'902.8069764003528px 538.5675029442205px',
							'902.8069764003528px 538.5675029442205px',
							'923.4282451426736px 537.6539024303202px',
							'923.4282451426736px 537.6539024303202px',
							'941.7002554206795px 536.3226559672083px',
							'952.6634615874829px 534.5476606830591px',
							'967.6334585795348px 533.9733975028932px',
							'970.5830830958414px 533.2033627840344px',
							'975.9080689482888px 532.7987682707358px',
							'983.3995931622712px 532.7465625270843px',
							'990.5517800425191px 530.984618678848px',
							'997.5995554354643px 530.9715672429352px',
							'1006.7877663181185px 530.9715672429352px',
							'1014.1096218652337px 530.2015325240764px',
							'1016.8765262787604px 529.3662406256532px',
							'1023.1151126451081px 529.1965719587861px',
							'1030.4108653203975px 528.2960228807985px',
							'1038.0459553294213px 527.408525238724px',
							'1043.631969900126px 527.408525238724px',
							'1049.8183505228221px 527.408525238724px',
							'1049.8183505228221px 527.408525238724px',
							'1064.501215924791px 524.7460323125003px',
							'1073.5719638842297px 522.6055968227911px',
							'1077.0828001447894px 521.6006362575008px',
							'1087.2107144131699px 519.7081780501359px',
							'1101.7369625841843px 516.4714219437462px',
							'1107.218565667586px 516.3670104564434px',
							'1117.7510744492652px 514.5398094286428px',
							'1134.796249751462px 512.0469851692864px',
							'1138.7377833971461px 511.2377961426889px',
							'1149.2963950506507px 510.19368126966003px',
							'1160.7816586539686px 509.20177214028257px',
							'1164.2924949145283px 508.31427449820796px',
							'1169.8263037415816px 507.4267768561334px',
							'1176.952387750004px 506.7089478809261px',
							'1187.1325077620356px 505.66483300789713px',
							'1189.7950006882593px 505.63873013607144px',
							'1195.9813813109556px 505.6126272642457px',
							'1201.7892702921788px 505.59957582833283px',
							'1208.4063482999995px 503.9681463392252px',
							'1208.4063482999995px 503.9681463392252px',
							'1213.4964083060154px 503.8376319800966px',
							'1220.7660581094792px 502.950134338022px',
							'1232.0555501741042px 500.7574931046613px',
							'1238.4246508995805px 500.7574931046613px',
							'1242.0398986474431px 500.0266126935411px',
							'1253.2510820965908px 498.995549256425px',
							'1262.3218300560295px 497.2336054081888px',
							'1271.014086373995px 497.20750253636305px',
							'1273.7679393516087px 496.6984965357615px',
							'1285.031328544408px 495.51081586769106px',
							'1290.1996971659012px 495.45861012403964px',
							'1308.7718904699027px 495.39335294447534px',
							'1312.4523953973296px 495.38030150856247px',
							'1324.6946422835936px 495.38030150856247px',
							'1328.022758441373px 495.38030150856247px',
							'1335.5012312194426px 495.38030150856247px',
							'1348.2916384140467px 495.38030150856247px',
							'1353.6427271383197px 495.38030150856247px',
							'1367.7774322319485px 495.38030150856247px',
							'1377.1875175251214px 495.38030150856247px',
							'1387.8896949736677px 495.38030150856247px',
							'1400.2885590908859px 495.38030150856247px',
							'1411.3039710013409px 494.5058553024008px',
							'1423.428754964389px 493.5922547885005px',
							'1432.2906799492218px 493.5922547885005px',
							'1440.565290317976px 493.5922547885005px',
							'1454.8305097707332px 493.5922547885005px',
							'1458.889506339633px 493.5922547885005px',
							'1473.1677772283033px 493.5922547885005px',
							'1479.4716207742154px 493.5922547885005px',
							'1493.6976859192341px 491.51707647835553px',
							'1499.0487746435072px 491.38656211922694px',
							'1508.4980142444188px 491.33435637557545px',
							'1522.9329023640432px 491.2952020678369px',
							'1534.0005200181497px 491.2952020678369px',
							'1536.780475867589px 491.2952020678369px',
							'1546.6082071099736px 491.2952020678369px',
							'1556.2662696854911px 489.5985153991649px',
							'1558.8374025603248px 489.5332582196006px',
							'1563.9405140022534px 489.49410391186206px',
							'1564.9454745675437px 489.49410391186206px',
							'1567.5035560064646px 489.49410391186206px',
							'1570.2313061122527px 489.49410391186206px',
							'1570.2313061122527px 489.49410391186206px',
							'1571.4450896521487px 489.49410391186206px',
							'1571.4450896521487px 489.49410391186206px',
							'1570.6228491896384px 489.49410391186206px',
							'1560.3905234339552px 493.0049401724217px',
							'1550.158197678272px 500.97936751517994px',
							'1532.5779135036478px 510.8723559371288px',
							'1511.6042559916798px 528.6092573427072px',
							'1487.9158998098364px 543.6314600784106px',
							'1479.7587523642983px 551.7755560880361px',
							'1479.7587523642983px 551.7755560880361px',
							'1423.7289379903848px 590.446960697844px',
							'1393.8280983140196px 609.44985138697px',
							'1378.9625128092707px 622.057538478794px',
							'1368.7301870535873px 630.0319658215523px',
							'1361.6824116606424px 637.0536383426715px',
							'1358.1585239641697px 638.802530754995px',
							'1350.1710451854988px 644.5321111207411px',
							'1343.1232697925536px 648.0298959453879px',
							'1340.5651883536327px 650.561874512483px',
							'1335.7622599376998px 653.5767562083539px',
							'1331.9251377793187px 657.3747240589965px',
							'1329.3670563403978px 659.9067026260917px',
							'1324.5641279244649px 661.1726919096392px',
							'1322.006046485544px 663.7046704767343px',
							'1317.203118069611px 665.4535628890577px',
							'1312.4001896536781px 666.7195521726053px',
							'1307.5972612377452px 669.7344338684762px',
							'1302.7943328218123px 669.7344338684762px',
							'1295.7465574288672px 671.4833262807996px',
							'1285.514231673184px 673.2322186931231px',
							'1272.0973555547625px 673.2322186931231px',
							'1251.9720413771304px 675.4640142342223px',
							'1234.3917572025064px 677.6958097753215px',
							'1216.8114730278821px 677.6958097753215px',
							'1199.2311888532581px 679.9276053164209px',
							'1185.8143127348367px 679.9276053164209px',
							'1175.5819869791535px 679.9276053164209px',
							'1165.34966122347px 679.9276053164209px',
							'1158.3018858305252px 679.9276053164209px',
							'1148.0695600748418px 679.9276053164209px',
							'1141.0217846818969px 679.9276053164209px',
							'1132.6949685694913px 679.9276053164209px',
							'1124.70748979082px 678.6485645969605px',
							'1117.6597143978752px 675.1246769004879px',
							'1110.61193900493px 669.8388453557791px',
							'1105.3261074602212px 662.7910699628341px',
							'1098.278332067276px 657.5052384181251px',
							'1092.0397457009285px 647.272912662442px',
							'1084.9919703079834px 640.2251372694968px',
							'1081.4680826115107px 633.1773618765518px',
							'1076.1822510668019px 626.1295864836067px',
							'1070.4135163933172px 615.8972607279235px',
							'1064.6447817198325px 602.1410472757677px',
							'1058.8760470463478px 591.9087215200844px',
							'1053.590215501639px 584.8609461271393px',
							'1046.0595369799182px 571.1047326749836px',
							'1042.5356492834455px 567.580844978511px',
							'1039.011761586973px 560.533069585566px',
							'1034.2088331710402px 555.730141169633px',
							'1028.9230016263314px 548.6823657766879px',
							'1024.1200732103985px 543.879437360755px',
							'1018.8342416656895px 536.8316619678099px',
							'1012.2693694015203px 528.5048458554044px',
							'1007.4664409855874px 523.7019174394715px',
							'999.1396248731819px 517.1370451753022px',
							'993.8537933284731px 511.8512136305934px',
							'989.0508649125401px 508.8102290628967px',
							'982.003089519595px 505.28634136642415px',
							'977.200161103662px 502.2453567987275px',
							'972.3972326877291px 499.20437223103085px',
							'965.3494572947841px 495.6804845345583px',
							'958.301681901839px 493.918540686322px',
							'951.2539065088939px 490.3946529898495px',
							'944.2061311159488px 488.6327091416132px',
							'933.9738053602655px 486.8707652933769px',
							'926.9260299673205px 485.1088214451407px',
							'923.4021422708479px 483.3468775969044px',
							'906.461378455954px 478.8571836428801px',
							'896.2290527002707px 476.612336665868px',
							'878.9489515516424px 472.6055458406195px',
							'874.1460231357095px 469.56456127292284px',
							'867.0982477427643px 467.8026174246866px',
							'864.5401663038435px 466.5235767052262px',
							'861.9820848649227px 465.24453598576576px',
							'859.424003426002px 465.24453598576576px',
							'856.8659219870812px 463.96549526630537px',
							'855.5868812676207px 462.68645454684497px',
							'854.3078405481604px 461.4074138273846px',
							'853.0287998286999px 461.4074138273846px',
							'852.0499421352354px 460.42855613392px',
							'850.9927758262936px 460.42855613392px',
							'848.6565687978914px 459.1495154144596px',
							'847.3775280784309px 457.8704746949992px',
							'845.0413210500288px 455.53426766659703px',
							'842.483239611108px 454.2552269471366px',
							'839.9251581721873px 452.9761862276762px',
							'837.3670767332665px 451.6971455082158px',
							'835.0308697048642px 450.639979199274px',
							'832.4727882659434px 449.3609384798136px',
							'830.3584556480599px 447.2466058619301px',
							'829.4318036982468px 447.2466058619301px',
							'828.5051517484336px 445.9675651424697px',
							'827.4479854394918px 445.9675651424697px',
							'826.5213334896787px 445.9675651424697px',
							'825.542475796214px 444.9887074490051px',
							'823.2062687678119px 444.9887074490051px',
							'822.1491024588702px 444.9887074490051px',
							'821.0919361499284px 444.9887074490051px',
							'820.0347698409867px 444.9887074490051px',
							'818.9776035320449px 443.93154114006336px',
							'817.9204372231031px 443.93154114006336px',
							'816.6413965036427px 443.93154114006336px',
							'814.3051894752406px 443.93154114006336px',
							'813.0261487557801px 442.6525004206029px',
							'811.9689824468384px 442.6525004206029px',
							'809.6327754184362px 441.3734597011425px',
							'808.5756091094944px 441.3734597011425px',
							'807.5184428005526px 441.3734597011425px',
							'806.4612764916109px 441.3734597011425px',
							'805.4041101826691px 441.3734597011425px',
							'804.477458232856px 440.44680775132935px',
							'803.6030120266943px 440.44680775132935px',
							'803.6030120266943px 440.44680775132935px',
							'805.0517214130219px 440.44680775132935px',
							'806.1219391578766px 440.44680775132935px',
							'807.0877454154282px 440.44680775132935px',
							'809.554466802959px 440.44680775132935px',
							'812.2039082932698px 440.44680775132935px',
							'814.7489382962779px 440.44680775132935px',
							'819.9303583536837px 440.44680775132935px',
							'856.6570990124753px 440.44680775132935px',
							'872.501542210689px 440.44680775132935px',
							'875.1118293932612px 440.44680775132935px',
							'888.0196995110811px 440.44680775132935px',
							'890.2645464880932px 440.44680775132935px',
							'901.7498100914111px 440.44680775132935px',
							'914.1878285163679px 440.44680775132935px',
							'925.7644521710758px 440.44680775132935px',
							'943.5013535766543px 437.9017777483214px',
							'946.1377436310522px 437.3014116963298px',
							'966.5110350910287px 436.8837657471182px',
							'989.1683278357559px 436.85766287529253px',
							'1016.1978516112915px 436.85766287529253px',
							'1043.6450213360388px 436.85766287529253px',
							'1077.683166196781px 436.85766287529253px',
							'1111.8779282884775px 436.85766287529253px',
							'1146.4642334575599px 436.85766287529253px',
							'1151.2019046939286px 436.85766287529253px',
							'1178.6621258545888px 436.85766287529253px',
							'1196.2946157728643px 436.85766287529253px',
							'1214.3447516403514px 436.85766287529253px',
							'1233.5956196118218px 436.85766287529253px',
							'1259.0198167700755px 436.85766287529253px',
							'1273.4808077615257px 436.85766287529253px',
							'1285.4359230577068px 436.85766287529253px',
							'1296.8689809173732px 436.85766287529253px',
							'1306.0441403641148px 436.85766287529253px',
							'1317.3466838646525px 436.85766287529253px',
							'1319.6176337134905px 436.85766287529253px',
							'1330.0718338796923px 436.85766287529253px',
							'1338.4378042998364px 436.85766287529253px',
							'1347.325832156495px 436.85766287529253px',
							'1359.5680790427589px 436.85766287529253px',
							'1372.3976405451015px 436.85766287529253px',
							'1387.380688973066px 436.85766287529253px',
							'1395.4203734953887px 436.85766287529253px',
							'1396.7777228303262px 436.85766287529253px',
							'1399.4010614488113px 436.85766287529253px',
							'1402.8074862220683px 436.85766287529253px',
							'1403.8124467873586px 436.85766287529253px',
							'1404.9087674040388px 436.85766287529253px',
							'1405.8745736615906px 436.85766287529253px',
							'1405.8745736615906px 436.85766287529253px',
							'1410.0379817177934px 469.40794404196856px',
							'1419.6307871137465px 485.4090044711365px',
							'1434.3789096952796px 529.6533722157362px',
							'1450.8628732532234px 578.6354111967046px',
							'1460.9385817779523px 616.7586554981723px',
							'1467.3337853752544px 648.7607763565081px',
							'1470.0484840451295px 670.4783657155093px',
							'1472.7631827150046px 692.1959550745105px',
							'1472.7631827150046px 709.7501363773089px',
							'1472.7631827150046px 723.1409096239046px',
							'1472.7631827150046px 736.5316828705002px',
							'1472.7631827150046px 746.7379057543577px',
							'1472.7631827150046px 756.9441286382153px',
							'1472.7631827150046px 773.8457381453705px',
							'1472.7631827150046px 784.0519610292281px',
							'1472.7631827150046px 797.4427342758238px',
							'1472.7631827150046px 810.8335075224194px',
							'1472.7631827150046px 828.3876888252179px',
							'1474.9949782561039px 838.5939117090753px',
							'1476.7438706684272px 845.6155842301947px',
							'1479.7587523642983px 850.392409774302px',
							'1489.9649752481557px 858.3668371170602px',
							'1503.3557484947514px 865.062223740358px',
							'1516.7465217413471px 873.9894059047551px',
							'1526.9527446252046px 879.7320377064141px',
							'1537.4852534068837px 886.7406587916206px',
							'1540.9960896674434px 888.489551203944px',
							'1554.8306117350762px 900.5621294233407px',
							'1559.5943858432706px 908.8497912280076px',
							'1567.8689962120247px 920.6482892932341px',
							'1569.617888624348px 924.1591255537938px',
							'1573.8987596037666px 931.4679296649962px',
							'1573.8987596037666px 932.7339189485438px',
							'1575.164748887314px 933.7780338215726px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

const TimelineLeftDragCompositionContent = () => {
	const {width, height} = useVideoConfig();

	return (
		<CloseUpFrame>
			<div
				style={{
					position: 'absolute',
					width: 1920,
					height: 1080,
					left: '50%',
					top: '50%',
					translate: '-50% -50%',
					scale: Math.min(width / 1920, height / 1080),
					overflow: 'hidden',
				}}
			>
				<TimelineLeftDragContent />
			</div>
		</CloseUpFrame>
	);
};

export const TimelineLeftDragComposition = Interactive.create({
	Component: TimelineLeftDragCompositionContent,
	layout: 'absolute-fill',
	schema: {},
});
